export default __webpack_public_path__ + "static/Vol 3 - TA 2B - EDS-f26883ada08967d75e02d7bfeda34139.pdf";